import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import GLightbox from 'glightbox';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, Classes, Events } from './constants';
import { fixMobileHover, getCookiesAllowed, initGTM, isDisclaimerAccepted, isTouchScreen, setCookiesAllowed, setDisclaimerAccepted, smoothScrollTo, sortAnimations, wait } from './helpers';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- Fix Scroll ----------

history.scrollRestoration = "manual";


// ---------- Touch Screen ----------

if(isTouchScreen()) {
	$Elements.html.addClass('touchscreen');
}

// ---------- Fix VH ----------

$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
$Elements.window.trigger('resize');

// ---------- jQuery Related ----------

$Elements.document.on(Events.page.enter, async() => {

	// ---------- Fix Mobile Hover ----------

	fixMobileHover();

	// ---------- Handle Aniamtions ----------

	ScrollTrigger.matchMedia(sortAnimations(Animations));

	// ---------- Links ----------

	$Elements.PageWrapper.on('click', 'a[href="#"], .void-link', (e) => e.preventDefault());

	$Elements.PageWrapper.on('click', '[data-scroll-to], [target="scroll-to"]', function(e) {
		e.preventDefault();

		const self = $(this);
		const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

		if(target.length) {
			smoothScrollTo(target);
		}
	});

	$Elements.PageWrapper.on('click', '.select-dropdown .dropdown-menu .btn', function() {
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
	});


	// ----------- Target on infographic-------------
	$('.explanation-column .image, .text-article-section .infographie .image').each(function() {
		const imageSrc = this.getAttribute('src');

		// Add link for ligthbox
		const link = document.createElement('a');
		link.setAttribute('target', 'lightbox');
		link.setAttribute('href', imageSrc);
		link.setAttribute('rel', imageSrc);
		link.classList.add('link-glightbox');

		this.parentNode.insertBefore(link, this);
		link.appendChild(this);

		// Add button to similar larger view
		const button = document.createElement('button');
		button.setAttribute('type', 'button');
		button.textContent = 'Agrandir l’image';
		button.classList.add('larger-view-button');

		this.parentNode.appendChild(button);
	});

	// ---------- GLightbox ----------
	$('[target="lightbox"]').each(function() {

		if($(this).attr('data-size') === 'full') {

			GLightbox({
				selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"][data-size="full"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				width: 'auto',
				height: 'auto',
				videosWidth: 1280,
				skin: 'fullscreen',
			});
		}
		else {

			GLightbox({
				selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		}
	});

	$('[target^="lightbox-gallery"]').each(function() {

		if($(this).attr('data-size') === 'full') {

			GLightbox({
				selector: 'a[target="' + this.attributes.target.value + '"][data-size="full"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				width: 'auto',
				height: 'auto',
				videosWidth: 1280,
				skin: 'fullscreen',
			});
		}
		else {

			GLightbox({
				selector: 'a[target="' + this.attributes.target.value + '"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		}
	});

	// ---------- Cookies ----------

	initGTM();

	if(!getCookiesAllowed()) {

		const cookies = document.querySelector('#cookies-allowed');

		if(cookies) {

			cookies.classList.remove(Classes.hidden);
			await wait(100);
			cookies.classList.add(Classes.show);

			$(cookies).on('click', '[data-bs-dismiss="alert"]', function() {
				setCookiesAllowed(this.dataset.allowed);
			});
		}
	}


	// ---------- Disclaimer ----------

	if(!isDisclaimerAccepted()) {

		const disclaimer = document.querySelector('#disclaimer');

		if(disclaimer) {

			disclaimer.classList.remove(Classes.hidden);
			$Elements.body.addClass(Classes.disclaimer);

			$(disclaimer).on('close.bs.alert', function() {
				setDisclaimerAccepted();
				$Elements.body.removeClass(Classes.disclaimer);
			});
		}
	}


	//------------- Thématique colors --------------

	const medicalColor = document.getElementById('page-wrapper').dataset.thematiqueMedical;
	const accidentsColor = document.getElementById('page-wrapper').dataset.thematiqueAccidents;
	const agressionsColor = document.getElementById('page-wrapper').dataset.thematiqueAgressions;
	const cabinetColor = document.getElementById('page-wrapper').dataset.thematiqueCabinet;
	const expositionsColor = document.getElementById('page-wrapper').dataset.thematiqueExpositions;

	if(medicalColor) {
		document.documentElement.style.setProperty('--tc-medical-color', medicalColor);
	}
	if(accidentsColor) {
		document.documentElement.style.setProperty('--tc-accidents-color', accidentsColor);
	}
	if(agressionsColor) {
		document.documentElement.style.setProperty('--tc-agressions-color', agressionsColor);
	}
	if(cabinetColor) {
		document.documentElement.style.setProperty('--tc-cabinet-color', cabinetColor);
	}
	if(expositionsColor) {
		document.documentElement.style.setProperty('--tc-expositions-color', expositionsColor);
	}

	let currentThematique;
	let currentColor;

	if(document.getElementById('summary-post')) {
		currentThematique = document.getElementById('summary-post').dataset.currentColor;
	}

	if(document.getElementById('current-form')) {
		currentThematique = document.getElementById('current-form').dataset.currentColor;
	}

	switch(currentThematique) {
		case 'medical':
			currentColor = medicalColor;
			break;
		case 'accidents':
			currentColor = accidentsColor;
			break;
		case 'agressions':
			currentColor = agressionsColor;
			break;
		case 'expositions':
			currentColor = expositionsColor;
			break;
		default:
			currentColor = cabinetColor;
	}
	document.documentElement.style.setProperty('--tc-current-color', currentColor);

	//------------- Button Back to top --------------

	const buttonBackToTop = document.getElementById("BackToTop");
	const button = buttonBackToTop.querySelector('button');

	if(buttonBackToTop) {
		window.addEventListener("scroll", function() {
			if(window.scrollY > 100) {
				buttonBackToTop.classList.add("show");
			}
			else {
				buttonBackToTop.classList.remove("show");
			}
		});

		if(button) {
			button.addEventListener("click", function() {

				window.scrollTo({
					top: 0,
					behavior: "smooth"
				});
			});
		}
	}

	//------------- Hero dynamic height --------------
	let sectionHeroHeight = document.querySelector('.hero-section');

	if(sectionHeroHeight && window.innerWidth >= 1024) {
		document.documentElement.style.setProperty('--tc-hero-height', sectionHeroHeight.offsetHeight + 'px');
	}

	//------------- Article dynamic height --------------
	let asideHeight = document.querySelector('.aside-section');

	if(asideHeight && window.innerWidth >= 1024) {
		document.documentElement.style.setProperty('--tc-aside-height', asideHeight.offsetHeight + 'px');
	}

	// ----------- Toc Summary -------------
	const linkTarget = window.location.href;
	const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

	if(sectionTarget.substring(0, 1) === '#') {

		const section = $(sectionTarget);

		if(section.length) {
			smoothScrollTo(section, 0);
		}
	}
});
